const { getAdaRoot, getDismissButton } = require('./elements');

const createDismissButton = (pluginOptions) => {
  if (!window || !window.adaEmbed) return false;

  const dismissButton = getDismissButton();
  if (dismissButton) dismissButton.parentElement.removeChild(dismissButton);

  const adaRoot = getAdaRoot();
  const button = document.createElement('button');
  button.classList.add('dismiss-ada-chatbot');
  button.addEventListener('click', () => dismissAda(pluginOptions), true);
  button.tabIndex = 0;
  button.innerHTML = 'Dismiss';
  adaRoot.appendChild(button);
  
  return true;
};

const dismissAda = (pluginOptions = {}) => {
  const { dismissDuration } = pluginOptions;
  document.documentElement.classList.add('ada-chatbot-dismissed');

  try {
    if (dismissDuration === 'session') {
      sessionStorage.setItem('ada-chatbot-dismissed', 'true');
    } else if (typeof dismissDuration === 'number') {
      const expires = Date.now() + (dismissDuration * 60 * 60 *1000);
      localStorage.setItem('ada-chatbot-dismissed', 'true');
      localStorage.setItem('ada-chatbot-dismiss-expires', expires);
    }
  } catch(e) {
    return false;
  }
    
  return true;
};

const undismissAda = () => {
  document.documentElement.classList.remove('ada-chatbot-dismissed');
};

const isAdaDismissed = (pluginOptions) => {
  const { dismissButton, dismissDuration } = pluginOptions;
  if (!window || !window.adaEmbed || !dismissButton) return false;

  try {
    if (dismissDuration === 'session') {
      return !!sessionStorage.getItem('ada-chatbot-dismissed');
    } else if (typeof dismissDuration === 'number') {
      const expires = parseInt(localStorage.getItem('ada-chatbot-dismiss-expires') || '0', 10);
      if (Date.now() > expires) {
        localStorage.removeItem('ada-chatbot-dismissed');
        localStorage.removeItem('ada-chatbot-dismiss-expires');
      }
      return !!localStorage.getItem('ada-chatbot-dismissed');
    }
  } catch(e) {
    return false;
  }

  return false;
};

module.exports = {
  createDismissButton,
  dismissAda,
  undismissAda,
  isAdaDismissed,
};

